import { InformationCircleIcon } from "@heroicons/react/24/solid";
import React from "react";

import { Dialog, Paragraph } from "@fronterahealth/frontera-ui-components";

interface DiscardChangesDialogProps {
  open: boolean;
  setOpen: (val: boolean) => void;
  handleDiscardChanges: () => void;
}

export const DiscardChangesDialog: React.FC<DiscardChangesDialogProps> = ({ open, setOpen, handleDiscardChanges }) => {
  return (
    <Dialog
      size="xl"
      showCloseButton={false}
      title="Discard Changes?"
      open={open}
      setOpen={() => {}}
      primaryButton={{
        text: "Yes, discard changes",
        onClick: () => {
          setOpen(false);
          handleDiscardChanges();
        },
        type: "submit",
      }}
      secondaryButton={{
        text: "No, continue editing",
        onClick: () => setOpen(false),
      }}
    >
      <div className="py-2 flex flex-col gap-4">
        <Paragraph size="small" colorType="primary">
          If you go back or exit now, any unsaved or unimported edits you’ve made will be lost. This includes goals,
          targets, and other programming details you’ve added, edited, or updated.
        </Paragraph>
        <div className="flex p-4 bg-limestone-50 justify-between items-center gap-2">
          <InformationCircleIcon className="h-6 w-6" />
          <Paragraph size="small" colorType="primary">
            You can always upload or re-enter this plan again, but any current edits can’t be recovered.
          </Paragraph>
        </div>
      </div>
    </Dialog>
  );
};
